import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { CountrySelect } from "@/components/profile/dropdowns/CountrySelect";
import { ProvinceStateSelect } from "@/components/profile/dropdowns/ProvinceStateSelect";

interface AddressSectionProps {
  form: any;
}

export function AddressSection({ form }: AddressSectionProps) {
  return (
    <div className="space-y-4 md:space-y-6">
      <div className="border-b pb-2">
        <h4 className="text-lg font-medium">Address Information</h4>
        <p className="text-sm text-muted-foreground">Your residential address details</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
        <FormField
          control={form.control}
          name="streetNumber"
          render={({ field }) => (
            <FormItem>
              <FormLabel className="text-xs text-muted-foreground">Street Number</FormLabel>
              <FormControl>
                <Input placeholder="123" className="w-full" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="streetName"
          render={({ field }) => (
            <FormItem>
              <FormLabel className="text-xs text-muted-foreground">Street Name</FormLabel>
              <FormControl>
                <Input placeholder="Main Street" className="w-full" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="suiteAptUnit"
          render={({ field }) => (
            <FormItem>
              <FormLabel className="text-xs text-muted-foreground">Suite/Apt/Unit</FormLabel>
              <FormControl>
                <Input placeholder="Suite 100" className="w-full" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        <FormField
          control={form.control}
          name="country"
          render={({ field }) => (
            <FormItem>
              <FormLabel className="text-xs text-muted-foreground">Country</FormLabel>
              <FormControl>
                <CountrySelect value={field.value} onValueChange={field.onChange} placeholder="Select country" />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="provinceState"
          render={({ field }) => (
            <FormItem>
              <FormLabel className="text-xs text-muted-foreground">Province/State</FormLabel>
              <FormControl>
                <ProvinceStateSelect value={field.value} onValueChange={field.onChange} placeholder="Select" country={form.watch("country")} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="city"
          render={({ field }) => (
            <FormItem>
              <FormLabel className="text-xs text-muted-foreground">City</FormLabel>
              <FormControl>
                <Input placeholder="Toronto" className="w-full" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="postalCode"
          render={({ field }) => (
            <FormItem>
              <FormLabel className="text-xs text-muted-foreground">Postal Code</FormLabel>
              <FormControl>
                <Input placeholder="M5V 3A8" className="w-full" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>
    </div>
  );
}
